export class AuthenticationBaseService {
  getAccessToken(): Promise<any> {
    console.error(
      'Base AuthenticationBaseService provided. Needs an implementation of getAccessToken() method.'
    );
    return new Promise(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/authentication-base.service.ts